import axios from 'src/utils/axios';
import axiosFiles from 'axios';

const errorHandler = error => {
  let messages = '';

  if (!error) {
    messages = 'Erro interno de servidor.';
  } else {
    const { status } = error?.response || 500;
    messages = error?.response?.data?.messages || 500;

    switch (status) {
      case 404:
        messages = `Não foi possível comunicar com servidor da aplicação. Código: ${status}`;
        break;
      case 401:
        messages = `Acesso negado, favor faça o login. Código: ${status}`;
        break;
      case 500:
        messages = `Servidor indisponível no momento`;
        break;

      default:
        if (!messages) {
          messages = `Servidor indisponível no momento`;
        }
        break;
    }
  }

  return messages;
};

const getRequest = (url, resolve, reject) =>
  axios
    .get(url)
    .then(response => {
      const { data } = response;

      resolve(data);
    })
    .catch(error => {
      const messages = errorHandler(error);

      reject(messages);
    });

const getRequestWithParams = ({ url, resolve, reject, params }) =>
  axios
    .get(url, {
      params: { ...params },
    })
    .then(response => {
      const { data } = response;
      resolve(data);
    })
    .catch(error => {
      const messages = errorHandler(error);

      reject(messages);
    });

const postRequest = async (url, data, resolve, reject) => {
  return axios
    .post(url, data)
    .then(response => {
      resolve(response.data);
    })
    .catch(error => {
      const messages = errorHandler(error);
      reject(messages);
    });
};

const postFilesRequest = async ({ url, data, resolve, reject }) => {
  return axiosFiles
    .post(url, data, {
      headers: {
        'Content-Type': 'application/octet-stream',
      },
    })
    .then(response => {
      resolve(response.data);
    })
    .catch(error => {
      const messages = errorHandler(error);
      reject(messages);
    });
};

const putRequest = async (url, data, resolve, reject) => {
  return axios
    .put(url, data)
    .then(response => {
      resolve(response.data);
    })
    .catch(error => {
      const messages = errorHandler(error);
      reject(messages);
    });
};

const deleteRequest = async (url, data, resolve, reject) => {
  return axios
    .delete(url, {
      data: { ...data },
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(response => {
      resolve(response.data);
    })
    .catch(error => {
      const messages = errorHandler(error);
      reject(messages);
    });
};

const deleteRequestWithAuthorization = async (
  url,
  authorization,
  resolve,
  reject
) => {
  return axios
    .delete(url, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authorization}`,
      },
    })
    .then(response => {
      resolve(response.data);
    })
    .catch(error => {
      const messages = errorHandler(error);
      reject(messages);
    });
};

export {
  errorHandler,
  getRequest,
  getRequestWithParams,
  postRequest,
  postFilesRequest,
  putRequest,
  deleteRequest,
  deleteRequestWithAuthorization,
};
